module.exports = __webpack_public_path__ + "media/bootstrap-icons/lamp-fill-5ca68578.svg";